import { GetCustomer } from "screens/Customers/logic/GetCustomer";
import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetSalesTaxReport = async (startDate, endDate, TaxJurisdictions, ServiceTypes, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {        
      const queryParams = {
        startDate: startDate || '',
        endDate: endDate || '',
        TaxJurisdictions: TaxJurisdictions || '',
        ServiceTypes: ServiceTypes || '',
      }
      // console.log("queryParams:  "+queryParams)
      
      const response = await fetch(`${dev_baseUrl}/Reports/get-sales-tax-report`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(queryParams),
      });
      
      // console.log(response)
      // console.log("Query Parameters = "+queryParams);
      const data = await response.json();
      
      // Handle unauthorized
      if (!response.ok && data.statusCode === "Unauthorized") {
        navigate(`/login`);
        return []; // Return empty array on unauthorized
      }
      
      // Always return data.result or empty array
      if (response.ok && !data.isError && data.result) {
        return data.result; // Return the result array directly
      } else {
        // Return empty array for any error cases
        console.warn('API Error:', data.message);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return []; // Return empty array on network error
    }
  } else {
    console.warn('Access token is not available.');
    navigate(`/login`);
    return []; // Return empty array when no token
  }
};
